module.exports = __webpack_public_path__ + "static/media/qberry.18153759.png";